import type { TmWrappers } from '@/wrappers'

export const composePreviewModalId: TmWrappers = 'composePreviewModal'

export type ComposeMessageRouteQueryParams = {
  openCreditModal?: 'true'
}

export const scheduleRouteHash = '#schedule'
